import React from 'react';
import '~/features/chatbot/styles/chatbot.css';

const LoadingIndicator: React.FC = () => {
    return (
        <div className="display-flex margin-bottom-10 justify-content-start" data-testid="loading-indicator">
            <div className="bg-lighter rounded padding-10 padding-left-15 padding-right-15">
                <div className="display-flex align-items-center gap-5">
                    <span className="chatbot-loading-dot" style={{ animationDelay: '0s' }} data-testid="loading-dot" />
                    <span className="chatbot-loading-dot" style={{ animationDelay: '0.16s' }} data-testid="loading-dot" />
                    <span className="chatbot-loading-dot" style={{ animationDelay: '0.32s' }} data-testid="loading-dot" />
                </div>
            </div>
        </div>
    );
};

export default LoadingIndicator;
